export type TAvatar = {
  name: string;
  prompt: string;
  voice: string;
  language: string;
  behavior: string;
  type: string;
  greeting: string;
  scene: string;
  logo: string;
  _id?: string;
};

export interface IAvatarSettings {
  initialChatEngine: string;
  initialTtsEngine: string;
  initialVoiceId: string;
  initialCamera: { id: string };
  initialCharacter: { id: string; title: string; icon: string };
  initialScene: { id: string; title: string };
  initialCharacterPrompt: string;
  logo: string;
  language: string,
  greeting: string,
};
